import type { DateRange } from "react-day-picker";
import type {
  ComparisonTimeFrame,
  RelativeTimeFrame,
} from "schemas/utils/analytics";

export function calculateDelta(
  newValue: number | undefined,
  oldValue: number | undefined,
) {
  if (!oldValue || newValue === undefined) {
    return 0;
  }

  return oldValue === 0 ? newValue : ((newValue - oldValue) / oldValue) * 100;
}

/**
 * Given a selected timeframe/period, returns true if it's a custom date range.
 * If it returns true, we can be 100% sure that the value has a .from/.to
 *
 * @author Max 2024-09-17
 */
export function isCustomDateRange(
  value: ComparisonTimeFrame | RelativeTimeFrame | DateRange,
): value is { from: Date; to: Date } {
  return (
    (value as DateRange).from !== undefined &&
    (value as DateRange).to !== undefined
  );
}

/**
 * Sanitizes the page URL path by replacing "/" with "Homepage".
 *
 * @author Kurt 2024-10-13
 */
export function sanitizePageUrlPath(urlPath: string) {
  return urlPath !== "/" && urlPath !== "" ? urlPath : "Homepage";
}
